import Paragraph from "../components/paragraph/Paragraph";
import { ReactComponent as WhyIlustration } from "../assets/images/why-ilustration.svg";
import { ReactComponent as WhatIlustration } from "../assets/images/what-ilustration.svg";
import { ReactComponent as HowIlustration } from "../assets/images/how-ilustration.svg";
import { useReveal } from "../hooks/useReveal";
import { trim } from "../utils/trim";
import { ReactNode } from "react";

const AboutBlock = ({
  className,
  children,
  stagger = false,
}: {
  className: string;
  children: ReactNode;
  stagger?: boolean;
}) => {
  const { ref, isVisible } = useReveal();

  return (
    <div
      ref={ref}
      className={trim(
        `reveal ${stagger ? "reveal--stagger" : ""} ${
          isVisible ? "is-visible" : ""
        } ${className}`
      )}
    >
      {children}
    </div>
  );
};

const AboutUs = () => {
  return (
    <div className="about-us">
      <AboutBlock className="about-us_header" stagger>
        <span className="about-us_eyebrow">O nama</span>
        <h1 className="about-us_title">
          NeoUm Media je najveća platforma praktičnog znanja, iz oblasti
          neurobiologije, psihologije i duhovnosti, a ujedno i zajednica vođena
          misijom da ohrabri evoluciju svesti na prostoru Balkana.
        </h1>
        <p className="about-us_lead">
          Verujemo da pravo znanje menja živote. Zato na jednom mestu spajamo
          nauku i praksu - dostupno svakome, u svakom trenutku, na maternjem
          jeziku.
        </p>
      </AboutBlock>

      <div className="about-us_list">
        <AboutBlock className="about-us_item">
          <WhatIlustration
            className="hover-float reveal-child"
            style={{ ["--reveal-delay" as string]: "0ms" }}
          />
          <div
            className="reveal-child"
            style={{ ["--reveal-delay" as string]: "120ms" }}
          >
            <span className="about-us_label">Šta je naš fokus?</span>
            <h2>Istraživanje limita ljudskog potencijala.</h2>
            <Paragraph variant="p2">
              Naš sadržaj ti pomaže da istražiš limite ljudskog potencijala, da
              se konektuješ sa svojim unutrašnjim bićem, kao i da se podsetiš
              koliko je tvoja biologija zapravo moćna jer sve što ti je potrebno
              za promenu se, zaista, nalazi unutar tebe.
            </Paragraph>
          </div>
        </AboutBlock>

        <AboutBlock className="about-us_item">
          <WhyIlustration
            className="hover-float reveal-child"
            style={{ ["--reveal-delay" as string]: "0ms" }}
          />
          <div
            className="reveal-child"
            style={{ ["--reveal-delay" as string]: "120ms" }}
          >
            <span className="about-us_label">Zašto ovo radimo?</span>
            <h2>
              Kako bismo ti pomogli da prevaziđeš specifičan izazov sa kojim se
              suočavaš u ovom trenutku.
            </h2>
            <Paragraph variant="p2">
              U našim edukacijama, emisijama i podkastima istražujemo različite
              oblasti koje ti mogu pomoći da prevaziđeš specifičan izazov koji
              imaš, kao i da naučiš kako da kreiraš realnost koja definiše tvoje
              biće i koju zaslužuješ da živiš.
            </Paragraph>
          </div>
        </AboutBlock>

        <AboutBlock className="about-us_item">
          <HowIlustration
            className="hover-float reveal-child"
            style={{ ["--reveal-delay" as string]: "0ms" }}
          />
          <div
            className="reveal-child"
            style={{ ["--reveal-delay" as string]: "120ms" }}
          >
            <span className="about-us_label">Kako to pravimo?</span>
            <h2>
              Sa tvojim finansijskim doprinosom imamo mogućnost da zajedno
              rastemo.
            </h2>
            <Paragraph variant="p2">
              Sa tvojom članarinom imamo mogućnost da proizvodimo, editujemo i
              delimo originalne serijale sa sjajnim edukatorima i misliocima
              našeg podneblja koji žele da Balkan bude najbolje mesto za život.
              <br />
              <br />
              Sami možemo samo donekle dogurati. Uz tvoju pomoć, možemo čuda
              napraviti! Radujemo se zajedničkom rastu i razvoju!
            </Paragraph>
          </div>
        </AboutBlock>
      </div>

      <AboutBlock className="about-us_offer" stagger>
        <span className="about-us_label">Šta dobijaš?</span>
        <h2 className="about-us_footer-title">
          Znanje koje možeš primeniti u svakodnevnom životu.
        </h2>
        <Paragraph variant="p2">
          Ne dobijaš samo informacije koje ćeš pogledati i zaboraviti. Dobijaš
          strukturisano znanje koje ti pomaže da razumeš zašto razmišljaš,
          osećaš i reaguješ na određeni način, kao i šta možeš da uradiš da bi
          postepeno menjao svoje obrasce.
        </Paragraph>
        <Paragraph variant="p2">
          Kroz edukativne programe, praktične protokole, vežbe i konkretne
          korake učiš kako da znanje preneseš iz teorije u svakodnevni život.
          Sadržaji su osmišljeni tako da složene teme iz neurobiologije,
          psihologije i duhovnosti postanu razumljive, primenljive i povezane sa
          stvarnim životnim izazovima.
        </Paragraph>
        <Paragraph variant="p2">
          Učiš svojim tempom, vraćaš se sadržajima kada su ti potrebni i biraš
          teme koje su u tom trenutku najvažnije za tvoj razvoj.
        </Paragraph>
      </AboutBlock>

      <AboutBlock className="about-us_footer" stagger>
        <span className="about-us_label">Pridruži nam se</span>
        <h2 className="about-us_footer-title">
          Zajedno gradimo prostor za rast, znanje i promenu.
        </h2>
        <Paragraph variant="p2">
          Svaki novi član je deo priče koja menja kulturu učenja na Balkanu.
          Hvala što rastemo zajedno.
        </Paragraph>
        <Paragraph variant="p2" className="about-us_contact">
          U svakom trenutku nas možeš kontaktirati i postaviti pitanja u vezi
          naše platforme na email{" "}
          <a href="mailto:office@neoummedia.com">office@neoummedia.com</a>.
        </Paragraph>
      </AboutBlock>
    </div>
  );
};

export default AboutUs;
